module.exports = __webpack_public_path__ + "img/gallery20.a55a8eba.jpg";